import React from "react"
import { DesktopTable } from "./desktopTable"
import { MobileTable } from "./mobileTable"

export const TableSelect = ({ isDesktop, ...props }) => isDesktop ?
  <DesktopTable {...props} /> : <MobileTable {...props} />
